import { render, staticRenderFns } from "./xiaohei_order_check_detail.vue?vue&type=template&id=89a312c8&scoped=true"
import script from "./xiaohei_order_check_detail.vue?vue&type=script&lang=js"
export * from "./xiaohei_order_check_detail.vue?vue&type=script&lang=js"
import style0 from "./xiaohei_order_check_detail.vue?vue&type=style&index=0&id=89a312c8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a312c8",
  null
  
)

export default component.exports